var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#paint0_linear_1911_390)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 22.3333H19V20.6666C19 20.0036 18.7366 19.3677 18.2678 18.8989C17.799 18.43 17.1631 18.1666 16.5 18.1666H11.5C10.837 18.1666 10.2011 18.43 9.73227 18.8989C9.26343 19.3677 9.00004 20.0036 9.00004 20.6666V22.3333H7.33337V20.6666C7.33337 19.5616 7.77236 18.5018 8.55376 17.7204C9.33516 16.939 10.395 16.5 11.5 16.5H16.5C17.6051 16.5 18.6649 16.939 19.4463 17.7204C20.2277 18.5018 20.6667 19.5616 20.6667 20.6666V22.3333ZM14 14.8333C13.3434 14.8333 12.6933 14.704 12.0866 14.4527C11.48 14.2014 10.9288 13.8331 10.4645 13.3688C10.0002 12.9046 9.63192 12.3534 9.38064 11.7467C9.12937 11.1401 9.00004 10.4899 9.00004 9.83331C9.00004 9.1767 9.12937 8.52652 9.38064 7.9199C9.63192 7.31327 10.0002 6.76207 10.4645 6.29778C10.9288 5.83349 11.48 5.46519 12.0866 5.21392C12.6933 4.96264 13.3434 4.83331 14 4.83331C15.3261 4.83331 16.5979 5.3601 17.5356 6.29778C18.4733 7.23546 19 8.50723 19 9.83331C19 11.1594 18.4733 12.4312 17.5356 13.3688C16.5979 14.3065 15.3261 14.8333 14 14.8333ZM14 13.1666C14.8841 13.1666 15.7319 12.8155 16.3571 12.1903C16.9822 11.5652 17.3334 10.7174 17.3334 9.83331C17.3334 8.94926 16.9822 8.10141 16.3571 7.47629C15.7319 6.85117 14.8841 6.49998 14 6.49998C13.116 6.49998 12.2681 6.85117 11.643 7.47629C11.0179 8.10141 10.6667 8.94926 10.6667 9.83331C10.6667 10.7174 11.0179 11.5652 11.643 12.1903C12.2681 12.8155 13.116 13.1666 14 13.1666Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1911_390",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD04E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A61B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account_icon.e4a649620ab634e61d564052b55572b1.svg";
export { ForwardRef as ReactComponent };